import { UserData } from "./user-data.interface";

export function createUserData(email = ""): UserData {
  return {
    email,
  };
}
